<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
  // 所有modal弹框居中代码
  .vertical-center-modal{
      display: flex;
      align-items: center;
      justify-content: center;
      .ivu-modal{
          top: 0;
      }
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    // padding:20px;
    box-sizing: border-box;
  }
  body{
    min-width: 1024px;
    font-size: 14px;
    background-color: #F7F7F7;
    color: #606060;
    margin: 0;
    padding: 0;
  }
  .rcyg-flex{
   display: flex;
   flex-direction: row;
   align-items: center;
  }
  .ivu-btn-group-vertical>.ivu-btn:first-child:not(:last-child){
    width: 20px;
  }
  .ivu-input{
    height:36px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue